import './Reports.scss'
import {PageTitle} from "../PageTitle/PageTitle";
import React, {useContext, useMemo} from "react";
import {NotificationMessageButton} from "../Notifications/NotificationMessageButton/NotificationMessageButton";
import {RoutingTabs} from "../../Utils/RoutingTabs/RoutingTabs";
import {FeatureFlags, SignDocCategories} from "../../Utils/Constants";
import {GeneratedReports} from "../GeneratedReports/GeneratedReports";
import {getAllSignDocTypes} from "../SignDoc/SignDocLib";
import {AdminDashboard} from "./AdminDashboard/AdminDashboard";
import {I18nReactContext} from "../../contexts/I18nContext";
import {CompanyReactContext} from "../../contexts/CompanyContext";
import {SignDocReports} from './SignDocReports/SignDocReports';
import {UserProgressReports} from './UserProgressReports/UserProgressReports';
import {CertificationDashboard} from './CertificationDashboard/CertificationDashboard';

const getAllTabs = ({i18n, featureFlags = {}}) => {
    return [
    {
        label: i18n.translate('ReportsPage.tabs.dashboard'),
        subPath: 'dashboard',
        element: <AdminDashboard types={[]} textType={'dashboard'}/>,
        requiredFeatureFlags: []
    },
    {
        label: i18n.translate('ReportsPage.tabs.userProgress'),
        subPath: 'userProgress',
        element: <UserProgressReports key={8}/>,
        requiredFeatureFlags: []
    },
    {
        label: i18n.translate('ReportsPage.tabs.allReports'),
        subPath: 'allReports',
        element: <SignDocReports
            types={getAllSignDocTypes()} // Pass all types, filtering happens in UI
            categories={[SignDocCategories.FORCE_COMPLETION, SignDocCategories.CERTIFICATION]} // Only show force completion and certification items
            forceCompletion={true}
        />,
        requiredFeatureFlags: [] // Show if any content exists
    },
    {
        label: i18n.translate('ReportsPage.tabs.generatedReports'),
        subPath: 'generatedReports',
        element: <GeneratedReports/>
    },
    {
        label: i18n.translate('ReportsPage.tabs.certifications'),
        subPath: 'certifications',
        element: <CertificationDashboard key={9} />,
        requiredFeatureFlags: [FeatureFlags.CERTIFICATION],
        alwaysShow: true,
        disabledTooltip: i18n.translate('routingTabs.featureRequiredTooltip', {
            context: { tabName: i18n.translate('ReportsPage.tabs.certifications') }
        })
    },
    {
        label: i18n.translate(featureFlags[FeatureFlags.OPERATION_MODE] ? 'ReportsPage.tabs.operation' : 'ReportsPage.tabs.KnowledgeCenter'),
        subPath: 'knowledgeCenter',
        element: <SignDocReports
            key={10}
            types={getAllSignDocTypes()} // Pass all types, filtering happens in UI
            categories={[SignDocCategories.KNOWLEDGE_CENTER]} // Only show knowledge center items
        />,
        requiredFeatureFlags: [FeatureFlags.KNOWLEDGE_CENTER],
        alwaysShow: true,
        disabledTooltip: i18n.translate('routingTabs.featureRequiredTooltip', {
            context: { tabName: i18n.translate('ReportsPage.tabs.KnowledgeCenter') }
        })
    },
]};

export const Reports = () => {
    const {i18n} = useContext(I18nReactContext);
    const companyContext = useContext(CompanyReactContext);

    // Get all tabs - RoutingTabs will handle feature flag checking and disabled state
    const allTabs = useMemo(() => {
        return getAllTabs({ i18n, featureFlags: companyContext.featureFlags });
    }, [i18n, companyContext.featureFlags]);

    return <div className="Reports MenuPage">
        <PageTitle title={i18n.translate('ReportsPage.title')}
                   size="small"
                   subTitle={i18n.translate('ReportsPage.subTitle')}
                   subTitleBold=""
                   noLogo={false}
                   customComponent={<NotificationMessageButton fullHeight={false}/>}

        />
        <div className="menuInnerPage">
            <div className="ReportsTabWrapper">
                <RoutingTabs tabs={allTabs} baseRoute={'reports'}/>
            </div>
        </div>

    </div>
}